import React from "react";
import { NavLink } from "react-router-dom";
import "./styles.scss";

class Footer extends React.Component {
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <div className="FooterMainWrapper">
                <div className="LinksWrapper">
                    <NavLink exact className="FooterHeading" to="/step1">
                        Get cardano
                    </NavLink>
                    <NavLink exact className="FooterHeading" to="/step2">
                        Stake at our pool
                    </NavLink>
                    <NavLink exact className="FooterHeading" to="/step3">
                        How we donate
                    </NavLink>
                    <NavLink exact className="FooterHeading" to="/donations">
                        Donations
                    </NavLink>
                </div>
                <div className="WatermarkWrapper">
                    <p>Communitypool &copy; 2021</p>
                </div>
            </div>
        );
    }
}

export default Footer;
